import CustomIcon from "./CustomIcon";
import * as solidIcons from "./solidIcons";

export default CustomIcon;
export { solidIcons };